import { cn } from "@/lib/utils"

export function PageHeader({
  title,
  description,
  action,
  eyebrow,
  variant = "default",
  className,
}: {
  title: string
  description?: string
  action?: React.ReactNode
  eyebrow?: React.ReactNode
  variant?: "default" | "gradient"
  className?: string
}) {
  return (
    <header
      className={cn(
        "relative flex flex-wrap items-end justify-between gap-4 border-b bg-background px-4 py-5 sm:px-6 sm:py-6",
        variant === "gradient" && "brand-gradient",
        className,
      )}
    >
      <div className="min-w-0">
        {eyebrow && (
          <div className="mb-1 text-xs font-medium uppercase tracking-wider text-primary">
            {eyebrow}
          </div>
        )}
        <h1 className="text-xl font-semibold tracking-tight sm:text-2xl">
          {title}
        </h1>
        {description && (
          <p className="mt-1 max-w-2xl text-sm text-muted-foreground">
            {description}
          </p>
        )}
      </div>
      {action && <div className="flex flex-wrap items-center gap-2">{action}</div>}
    </header>
  )
}
